import { IOS_HEADERS } from "../constants/ins_base_consts";
import { RequestParams } from "@/api/types";
import { transformParamsToString } from "@/api/utils/api_helpers";
import { isJSON } from "@/utils/lodash";
import { showLoginRequired } from "@/services/dialog_utils";
import IgSetHeaders from "@/api/ins_api_new/persisits/ig_set_headers";
import { act_users_action } from "@/services/earn_coins/observer/act_users_observer";
import { store } from "@/main";
import { GETTER_ONE_INS_LOGIN_USER_ID } from "@/store/constants/ins_user_info_types";
import ShowInsVerify from "@/utils/show_ins_verify";
import { handleIgHeaders } from "../utils/index";
/**
 * 设置默认headers
 * @param config
 */
export const defaultHeader = async (config: RequestParams) => {
  const iOSHeaders = await IOS_HEADERS();
  const { user_id }: any = config.extra_data;
  const igHeaders = await IgSetHeaders.getUserHeaders(user_id);
  const configHeaders = config.headers || {};
  const newHeaders = {
    ...iOSHeaders,
    ...configHeaders,
    ...igHeaders,
    "IG-INTENDED-USER-ID": user_id || "0"
  };
  config.headers = newHeaders;
  return config;
};

/**
 * 处理get方法的url以及post方法的body
 * @param config
 */
export const handleUrlBody = (config: RequestParams) => {
  if (config.method === "GET") {
    const newurl = config.params
      ? `${config.url}?${transformParamsToString(config.params)}`
      : config.url;
    config.url = newurl;
  }
  return config;
};

export const handleResponseHeaders = (responseData: any) => {
  const { headers, request } = responseData;
  const { user_id, return_headers } = request.extra_data;
  if (!return_headers) handleIgHeaders(headers, user_id);
  return responseData;
};

// 解密返回值
export const responseDataDecode = (responseData: any) => {
  const { data } = responseData;
  let atobString = atob(data);
  if (data) {
    isJSON(atobString) ? (atobString = JSON.parse(atobString)) : void 0;
    responseData.data = atobString;
    return responseData;
  } else {
    return responseData;
  }
};

// 处理返回的错误
export function responseToError(responseData: any) {
  console.log("responseToError", responseData);
  const { status_code, data, request, headers } = responseData;
  if (typeof data === "string" && data.includes("not-logged-in")) {
    const errorData = { data: { message: "login_required" }, request };
    insErrorHanlde(errorData);
    return Promise.reject(errorData);
  }
  if (status_code === 200) {
    const { return_headers } = request.extra_data;
    if (return_headers) {
      return {
        data,
        headers
      };
    } else {
      return data;
    }
  } else {
    // ins返回的错误,非登录的api需要处理
    insErrorHanlde(responseData);
    return Promise.reject(data);
  }
}

export const insErrorHanlde = (responseData: any) => {
  try {
    const { data, request } = responseData;
    const { extra_data } = request;
    const { user_id, not_show_veify } = extra_data;
    const userId = user_id || store.getters[GETTER_ONE_INS_LOGIN_USER_ID];
    const { message, comment_error_key, challenge } = data;
    switch (message) {
      case "login_required": {
        loginRequired(userId);
        return;
      }
      case "challenge_required": {
        user_id &&
          ShowInsVerify.addVerifyInfo(
            {
              user_id,
              challenge,
              show: false
            },
            not_show_veify
          );
        return;
      }
      case "feedback_required": {
        // comment feed不存在或者已关闭不需要使账号受限，排除这两种情况
        const shouldNotStartLimitation: boolean =
          comment_error_key === "comment_media_does_not_exist" ||
          comment_error_key === "comment_comments_disabled";
        // 一段时间内earn次数过多，需要出发limited times,时间为最大时间，不需要重新登录
        if (!shouldNotStartLimitation) {
          //
          act_users_action.feed_back_trigger_act_limit(user_id);
        }
        return;
      }
    }
  } catch (error) {
    void 0;
  }
};

export const loginRequired = (userId: string) => {
  // 弹出需要登陆的框：
  showLoginRequired(userId);
  // 改变act user的status
  act_users_action.trigger_login_required(userId);
};
